import { localUrl as appLocalUrl } from './app-path.js';
import SignupService from './services/signup-service';
import AuthService from './services/auth-service';
import SessionManager from './session-manager';
import { trackGa4CatalogEvent } from './analytics/ga4-event-tracker';

const Register = {
	currentEmail: null,

	getRedirectPath: function () {
		const params = new URLSearchParams(window.location.search);
		const redirect = String(params.get('redirect') || '').trim();

		if (!redirect) {
			return '';
		}

		if (!redirect.startsWith('/') || redirect.startsWith('//')) {
			return '';
		}

		if (redirect.includes('://') || redirect.includes('\\')) {
			return '';
		}

		return redirect;
	},

	resolvePostSignupRedirect: function () {
		const redirectPath = Register.getRedirectPath();

		if (!redirectPath) {
			return '';
		}

		if (!redirectPath.startsWith(appLocalUrl('/checkout'))) {
			return redirectPath;
		}

		const separator = redirectPath.includes('?') ? '&' : '?';
		const checkoutReturnTo = `${redirectPath}${separator}step=2`;
		return appLocalUrl(`/meu-climatempo/?section=profile-required&focus=cpf&next=addresses&returnTo=${encodeURIComponent(checkoutReturnTo)}`);
	},

	init: function () {
		if (!document.querySelector('.step-1-content')) {
			return;
		}

		Register.setupElements();
		Register.syncRedirectContext();
		Register.setupEventListeners();
		Register.setupCodeInputs();
		Register.setupInputMasks();
	},

	syncRedirectContext: function () {
		const redirectPath = Register.getRedirectPath();
		if (!redirectPath) {
			return;
		}

		const loginLink = document.querySelector(`a.register-link[href="${appLocalUrl('/login')}"]`);
		if (loginLink) {
			loginLink.setAttribute(
				'href',
				appLocalUrl(`/login?redirect=${encodeURIComponent(redirectPath)}`),
			);
		}
	},

	showMessage: function (container, message, type = 'error', duration = 5000) {
		const messageClass =
			type === 'success' ? 'success-message' : 'error-message';
		const $container = typeof container === 'string' ? $(container) : container;

		$container.find('.success-message, .error-message').remove();

		const $message = $(`<div class="${messageClass}">${message}</div>`);
		$container.prepend($message);

		const fadeDelay = type === 'success' ? 3000 : duration;
		setTimeout(() => {
			$message.fadeOut(() => $message.remove());
		}, fadeDelay);
	},

	setupElements: function () {
		Register.step1 = document.querySelector('.step-1-content');
		Register.step2 = document.querySelector('.step-2-content');
		Register.step3 = document.querySelector('.step-3-content');
		Register.step4 = document.querySelector('.step-4-content');

		Register.stepIndicator1 = document.querySelector('.step-1');
		Register.stepIndicator2 = document.querySelector('.step-2');
		Register.stepIndicator3 = document.querySelector('.step-3');

		Register.goStep2Btn = document.getElementById('goStep2');
		Register.goStep3Btn = document.getElementById('goStep3');
		Register.backStep1Btn = document.getElementById('backStep1');
		Register.registerBtn = document.getElementById('btnSendUserRegister');
		Register.resendOTPBtn = document.getElementById('resendOTP');

		Register.emailInput = document.getElementById('emailInputRegister');
		Register.codeInputs = document.querySelectorAll('.otp-input');
	},

	setupEventListeners: function () {
		const formStep1 = document.getElementById('formSendUserRegister');
		if (formStep1) {
			formStep1.addEventListener('submit', function (e) {
				e.preventDefault();

				const email = Register.emailInput.value.trim();
				if (!Register.validateEmail(email)) {
					Register.showMessage(
						'.step-1-content',
						'Por favor, insira um e-mail válido.',
					);
					return;
				}

				Register.sendVerificationCode(email);
			});
		}

		const formStep2 = document.getElementById('formValidateOTP');
		if (formStep2) {
			formStep2.addEventListener('submit', function (e) {
				e.preventDefault();

				const code = Register.getCode();
				if (code.length !== 6) {
					Register.showMessage(
						'.step-2-content',
						'Por favor, insira o código completo.',
					);
					return;
				}

				Register.verifyCode(code);
			});
		}

		if (Register.backStep1Btn) {
			Register.backStep1Btn.addEventListener('click', function (e) {
				e.preventDefault();
				Register.goToStep(1);
			});
		}

		const formStep3 = document.getElementById('formCompleteRegister');
		if (formStep3) {
			formStep3.noValidate = true;

			formStep3.addEventListener('submit', function (e) {
				e.preventDefault();
				Register.submitRegistration();
			});
		}

		const termsCheckbox = document.getElementById('termsAccepted');
		if (termsCheckbox && Register.registerBtn) {
			Register.registerBtn.addEventListener('click', function () {
				if (!termsCheckbox.checked) {
					Register.showMessage(
						'.step-3-content',
						'Você precisa aceitar os Termos de Uso e a Política de Privacidade.',
					);
				}
			});

			termsCheckbox.addEventListener('change', function () {
				if (termsCheckbox.checked) {
					$('.step-3-content .error-message').remove();
				}
			});
		}

		if (Register.resendOTPBtn) {
			Register.resendOTPBtn.addEventListener('click', function (e) {
				e.preventDefault();
				if (Register.currentEmail) {
					Register.sendVerificationCode(Register.currentEmail);
					Register.startResendTimer();
				}
			});
		}
	},

	setupCodeInputs: function () {
		if (!Register.codeInputs || Register.codeInputs.length === 0) return;

		const fillCodeFromDigits = function (digits, startIndex) {
			digits.forEach(function (digit, i) {
				if (startIndex + i < Register.codeInputs.length) {
					Register.codeInputs[startIndex + i].value = digit;
				}
			});

			const lastIndex = Math.min(
				startIndex + digits.length - 1,
				Register.codeInputs.length - 1,
			);

			if (lastIndex >= 0) {
				Register.codeInputs[lastIndex].focus();
			}
		};

		Register.codeInputs.forEach(function (input, index) {
			input.addEventListener('input', function (e) {
				const digits = String(e.target.value || '').replace(/\D/g, '');

				if (digits.length > 1) {
					e.target.value = '';
					fillCodeFromDigits(digits.split(''), index);
					return;
				}

				e.target.value = digits;

				if (
					e.target.value.length === 1 &&
					index < Register.codeInputs.length - 1
				) {
					Register.codeInputs[index + 1].focus();
				}
			});

			input.addEventListener('keydown', function (e) {
				if (e.key === 'Backspace' && e.target.value === '' && index > 0) {
					Register.codeInputs[index - 1].focus();
				}
			});

			input.addEventListener('keypress', function (e) {
				if (!/[0-9]/.test(e.key)) {
					e.preventDefault();
				}
			});

			input.addEventListener(
				'paste',
				function (e) {
					e.preventDefault();
					const pastedData = e.clipboardData.getData('text');
					const digits = pastedData.replace(/\D/g, '').split('');

					fillCodeFromDigits(digits, index);
				},
				{ passive: false },
			);
		});
	},

	validateEmail: function (email) {
		const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return re.test(email);
	},

	getCode: function () {
		let code = '';
		Register.codeInputs.forEach(function (input) {
			code += input.value;
		});
		return code;
	},

	translateErrorMessage: function (message) {
		let parsedMessage = message;

		if (typeof parsedMessage !== 'string' && parsedMessage) {
			if (typeof parsedMessage.message === 'string') {
				parsedMessage = parsedMessage.message;
			} else if (typeof parsedMessage.error === 'string') {
				parsedMessage = parsedMessage.error;
			} else if (typeof parsedMessage.originalData?.error === 'string') {
				parsedMessage = parsedMessage.originalData.error;
			} else if (typeof parsedMessage.originalData?.message === 'string') {
				parsedMessage = parsedMessage.originalData.message;
			} else {
				parsedMessage = String(parsedMessage);
			}
		}

		if (typeof parsedMessage !== 'string') {
			return 'Erro ao completar o cadastro';
		}

		const translations = {
			'Invalid OTP': 'Código de verificação inválido',
			'invalid otp': 'Código de verificação inválido',
			'Invalid OTP.': 'Código de verificação inválido',
			'OTP expired': 'Código de verificação expirado',
			'Failed to create user': 'Falha ao criar usuário',
			'Failed to create user.': 'Falha ao criar usuário',
			'User already exists': 'Usuário já existe',
			'Email already in use': 'E-mail já está em uso',
			'Email already registered':
				'Este e-mail já está cadastrado. Por favor, faça login ou use outro e-mail.',
			CPF_CNPJ_ALREADY_REGISTERED:
				'CPF já cadastrado. Use outro CPF ou faça login.',
			CPF_MUST_BE_VALID:
				'CPF inválido. Verifique o número informado.',
			DOCUMENT_VALUE_MUST_BE_NUMBERS:
				'CPF deve conter apenas números.',
			BIRTH_DATE_MUST_BE_OF_ISO_8601_FORMAT:
				'Data de nascimento inválida. Verifique os valores informados.',
			'Invalid email': 'E-mail inválido',
			'Invalid credentials': 'Credenciais inválidas',
			MINIMUM_UPPERCASE_CHARACTERS_ERROR:
				'A senha deve conter pelo menos 2 letras maiúsculas',
			MINIMUM_LOWERCASE_CHARACTERS_ERROR:
				'A senha deve conter pelo menos 2 letras minúsculas',
			MINIMUM_NUMERIC_CHARACTERS_ERROR:
				'A senha deve conter pelo menos 2 números',
			MINIMUM_SPECIAL_CHARACTERS_ERROR:
				'A senha deve conter pelo menos 2 caracteres especiais',
			MINIMUM_CHARACTERS_ERROR: 'A senha deve ter no mínimo 8 caracteres',
			MINIMUM_LENGTH_ERROR: 'A senha deve ter no mínimo 8 caracteres',
			'Password is too weak': 'A senha é muito fraca',
		};

		if (translations[parsedMessage]) {
			return translations[parsedMessage];
		}

		const lowerMessage = parsedMessage.toLowerCase();

		if (
			lowerMessage.includes('clients_cpf_cnpj_unique') ||
			lowerMessage.includes('duplicate key value violates unique constraint')
		) {
			return 'CPF já cadastrado. Use outro CPF ou faça login.';
		}

		for (const [key, value] of Object.entries(translations)) {
			if (lowerMessage === key.toLowerCase()) {
				return value;
			}
		}

		return parsedMessage;
	},

	goToStep: function (stepNumber) {
		[Register.step1, Register.step2, Register.step3, Register.step4].forEach(
			step => {
				if (step) step.classList.remove('active');
			},
		);

		switch (stepNumber) {
			case 1:
				if (Register.step1) Register.step1.classList.add('active');
				if (Register.stepIndicator2)
					Register.stepIndicator2.classList.remove('active');
				if (Register.stepIndicator3)
					Register.stepIndicator3.classList.remove('active');
				setTimeout(() => {
					if (Register.emailInput) Register.emailInput.focus();
				}, 100);
				break;
			case 2:
				if (Register.step2) Register.step2.classList.add('active');
				if (Register.stepIndicator1)
					Register.stepIndicator1.classList.add('active');
				if (Register.stepIndicator2)
					Register.stepIndicator2.classList.add('active');
				setTimeout(() => {
					if (Register.codeInputs && Register.codeInputs[0]) {
						Register.codeInputs[0].focus();
					}
				}, 100);
				break;
			case 3:
				if (Register.step3) Register.step3.classList.add('active');
				if (Register.stepIndicator2)
					Register.stepIndicator2.classList.add('active');
				if (Register.stepIndicator3)
					Register.stepIndicator3.classList.add('active');
				setTimeout(() => {
					const step3Inputs = [
						'inputName',
						'inputCPF',
						'inputBirthDate',
						'passwordInput',
					];
					step3Inputs.forEach(function (inputId) {
						const input = document.getElementById(inputId);
						if (input && input.value.trim().length > 0) {
							input.classList.add('has-value');
						}
					});
					const nameInput = document.getElementById('inputName');
					if (nameInput) nameInput.focus();
				}, 100);
				break;
			case 4:
				const stepsElement = document.querySelector('.steps');
				if (stepsElement) stepsElement.classList.add('hidden');

				if (Register.step4) Register.step4.classList.add('active');
				break;
		}
	},

	sendVerificationCode: async function (email) {
		const button = Register.goStep2Btn || Register.resendOTPBtn;
		const originalText = button ? button.textContent : '';
		if (button) {
			button.disabled = true;
			button.textContent = 'Enviando...';
		}

		try {
			const result = await SignupService.sendOtp(email);

			if (button) {
				button.disabled = false;
				button.textContent = originalText;
			}

			if (result.success) {
				Register.currentEmail = email;

				console.log('✅ Código de verificação enviado para:', email);

				Register.goToStep(2);
			} else {
				const errorMessage =
					result.error ||
					'Erro ao enviar código de verificação. Tente novamente.';
				const translatedMessage = Register.translateErrorMessage(errorMessage);

				Register.showMessage('.step-1-content', translatedMessage);
			}
		} catch (error) {
			if (button) {
				button.disabled = false;
				button.textContent = originalText;
			}
			console.error('Error:', error);
			Register.showMessage(
				'.step-1-content',
				'Erro ao conectar com o servidor. Tente novamente.',
			);
		}
	},

	verifyCode: async function (code) {
		const button = Register.goStep3Btn;
		const originalText = button.textContent;
		button.disabled = true;
		button.textContent = 'Verificando...';

		try {
			const result = await SignupService.verifyOtp(Register.currentEmail, code);

			button.disabled = false;
			button.textContent = originalText;

			if (result.success) {
				trackGa4CatalogEvent('verify_email_attempt', {
					user_id: result?.data?.userId || result?.data?.id,
					userid: result?.data?.userId || result?.data?.id,
				});
				Register.goToStep(3);
			} else {
				let errorMessage = result.error || 'Código de verificação inválido';
				errorMessage = Register.translateErrorMessage(errorMessage);
				Register.showMessage('.step-2-content', errorMessage);
				Register.codeInputs.forEach(input => (input.value = ''));
				if (Register.codeInputs[0]) Register.codeInputs[0].focus();
			}
		} catch (error) {
			button.disabled = false;
			button.textContent = originalText;
			console.error('Error:', error);
			Register.showMessage(
				'.step-2-content',
				error.message || 'Erro ao conectar com o servidor. Tente novamente.',
			);
		}
	},

	submitRegistration: async function () {
		const name = document.getElementById('inputName')
			? document.getElementById('inputName').value.trim()
			: '';
		const cpf = document.getElementById('inputCPF')
			? document.getElementById('inputCPF').value.trim()
			: '';
		const birthDate = document.getElementById('inputBirthDate')
			? document.getElementById('inputBirthDate').value.trim()
			: '';
		const password = document.getElementById('passwordInput')
			? document.getElementById('passwordInput').value
			: '';
		const termsAccepted = document.getElementById('termsAccepted')
			? document.getElementById('termsAccepted').checked
			: false;

		if (!name || !cpf || !birthDate || !password) {
			Register.showMessage(
				'.step-3-content',
				'Por favor, preencha todos os campos obrigatórios.',
			);
			return;
		}

		const cpfDigits = cpf.replace(/\D/g, '');
		if (cpfDigits.length !== 11) {
			Register.showMessage('.step-3-content', 'CPF deve conter 11 dígitos.');
			return;
		}

		const birthDatePattern = /^\d{2}\/\d{2}\/\d{4}$/;
		if (!birthDatePattern.test(birthDate)) {
			Register.showMessage(
				'.step-3-content',
				'Data de nascimento inválida. Use o formato DD/MM/AAAA.',
			);
			return;
		}

		const [birthDay, birthMonth, birthYear] = birthDate
			.split('/')
			.map(value => Number(value));
		const parsedBirthDate = new Date(
			Date.UTC(birthYear, birthMonth - 1, birthDay),
		);
		const isBirthDateValid =
			parsedBirthDate.getUTCFullYear() === birthYear &&
			parsedBirthDate.getUTCMonth() === birthMonth - 1 &&
			parsedBirthDate.getUTCDate() === birthDay;

		if (!isBirthDateValid) {
			Register.showMessage(
				'.step-3-content',
				'Data de nascimento inválida. Verifique os valores informados.',
			);
			return;
		}

		if (password.length < 8) {
			Register.showMessage(
				'.step-3-content',
				'A senha deve ter no mínimo 8 caracteres.',
			);
			return;
		}
		if ((password.match(/[A-Z]/g) || []).length < 2) {
			Register.showMessage(
				'.step-3-content',
				'A senha deve conter pelo menos 2 letras maiúsculas.',
			);
			return;
		}
		if ((password.match(/[a-z]/g) || []).length < 2) {
			Register.showMessage(
				'.step-3-content',
				'A senha deve conter pelo menos 2 letras minúsculas.',
			);
			return;
		}
		if ((password.match(/[0-9]/g) || []).length < 2) {
			Register.showMessage(
				'.step-3-content',
				'A senha deve conter pelo menos 2 números.',
			);
			return;
		}
		if ((password.match(/[^A-Za-z0-9]/g) || []).length < 2) {
			Register.showMessage(
				'.step-3-content',
				'A senha deve conter pelo menos 2 caracteres especiais.',
			);
			return;
		}

		if (!termsAccepted) {
			Register.showMessage(
				'.step-3-content',
				'Você precisa aceitar os Termos de Uso e a Política de Privacidade.',
			);
			return;
		}
		const button = Register.registerBtn;
		const originalText = button.textContent;
		button.disabled = true;
		button.textContent = 'Cadastrando...';

		const formattedBirthDate = `${String(birthYear)}-${String(birthMonth).padStart(2, '0')}-${String(birthDay).padStart(2, '0')}`;

		const userData = {
			email: Register.currentEmail,
			name: name,
			cpf: cpf.replace(/\D/g, ''),
			birthDate: formattedBirthDate,
			password: password,
			termsAccepted: termsAccepted,
		};

		try {
			const result = await SignupService.completeRegistration(userData);

			button.disabled = false;
			button.textContent = originalText;

			if (result.success) {
				Register.goToStep(4);
				const postSignupRedirect = Register.resolvePostSignupRedirect();

				const loginResult = await AuthService.login(
					Register.currentEmail,
					password,
					{
						redirect: postSignupRedirect || undefined,
					},
				);

				const completeUserData = SessionManager.getUserData();
				const registeredUserId = completeUserData?.userId;
				trackGa4CatalogEvent('sign_up_attempt', {
					user_id: registeredUserId,
					userid: registeredUserId,
					method: 'email',
					first_source: document.referrer || '(direct)',
					first_medium: 'web',
				});

				setTimeout(function () {
					window.location.href = loginResult.success
						? loginResult.redirect || appLocalUrl('/splash/cadastro')
						: appLocalUrl(`/login${Register.getRedirectPath() ? `?redirect=${encodeURIComponent(Register.getRedirectPath())}` : ''}`);
				}, 3000);
			} else {
				let errorMessage = result.error || 'Erro ao completar o cadastro';
				errorMessage = Register.translateErrorMessage(errorMessage);
				Register.showMessage('.step-3-content', errorMessage);
			}
		} catch (error) {
			button.disabled = false;
			button.textContent = originalText;
			console.error('Error:', error);
			Register.showMessage(
				'.step-3-content',
				error.message || 'Erro ao conectar com o servidor. Tente novamente.',
			);
		}
	},

	startResendTimer: function () {
		const resendBtn = Register.resendOTPBtn;
		const timerElement = document.getElementById('resendTimer');
		const timerSeconds = document.getElementById('timerSeconds');

		if (!resendBtn || !timerElement || !timerSeconds) return;

		let seconds = 60;
		resendBtn.style.display = 'none';
		timerElement.classList.remove('_none');

		const interval = setInterval(function () {
			seconds--;
			timerSeconds.textContent = seconds;

			if (seconds <= 0) {
				clearInterval(interval);
				resendBtn.style.display = 'inline';
				timerElement.classList.add('_none');
			}
		}, 1000);
	},

	setupInputMasks: function () {
		const updateLabelState = function (input) {
			if (!input) return;
			if (input.value.trim().length > 0) {
				input.classList.add('has-value');
			} else {
				input.classList.remove('has-value');
			}
		};

		const inputIds = [
			'inputCPF',
			'inputBirthDate',
			'inputName',
			'passwordInput',
			'emailInputRegister',
		];
		inputIds.forEach(function (inputId) {
			const input = document.getElementById(inputId);
			if (input) {
				input.addEventListener('input', function (e) {
					updateLabelState(e.target);
				});
				input.addEventListener('blur', function (e) {
					updateLabelState(e.target);
				});
				updateLabelState(input);
			}
		});

		const cpfInput = document.getElementById('inputCPF');
		const birthDateInput = document.getElementById('inputBirthDate');

		if (cpfInput) {
			cpfInput.addEventListener('input', function (e) {
				let value = e.target.value.replace(/\D/g, '');
				if (value.length > 11) value = value.substring(0, 11);

				if (value.length > 0) {
					if (value.length > 9) {
						value = value.replace(
							/^(\d{3})(\d{3})(\d{3})(\d{0,2}).*/,
							'$1.$2.$3-$4',
						);
					} else if (value.length > 6) {
						value = value.replace(/^(\d{3})(\d{3})(\d{0,3}).*/, '$1.$2.$3');
					} else if (value.length > 3) {
						value = value.replace(/^(\d{3})(\d{0,3}).*/, '$1.$2');
					}
				}

				e.target.value = value;
				updateLabelState(e.target);
			});
		}

		if (birthDateInput) {
			birthDateInput.addEventListener('input', function (e) {
				let value = e.target.value.replace(/\D/g, '');
				if (value.length > 8) value = value.substring(0, 8);

				if (value.length > 0) {
					if (value.length > 4) {
						value = value.replace(/^(\d{2})(\d{2})(\d{0,4}).*/, '$1/$2/$3');
					} else if (value.length > 2) {
						value = value.replace(/^(\d{2})(\d{0,2}).*/, '$1/$2');
					}
				}

				e.target.value = value;
				updateLabelState(e.target);
			});
		}
	},
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', Register.init);
} else {
	Register.init();
}

export default Register;
